import { Navigate, useParams } from "react-router-dom";
import { getSectionOperationsFallbackPath } from "../_utils";
import { useSectionOperationsAccess } from "./useSectionOperationsAccess";

export default function OperationsIndex() {
  const { sectionId } = useParams();
  const { ready, showCommittees, showSectionOfficeFacilityTabs, showGovernance, showNotifications } =
    useSectionOperationsAccess(sectionId);

  if (!sectionId || !ready) {
    return null;
  }

  return (
    <Navigate
      to={getSectionOperationsFallbackPath(sectionId, {
        showCommittees,
        showSectionOfficeFacilityTabs,
        showGovernance,
        showNotifications
      })}
      replace
    />
  );
}
